import { React, useState, useEffect, useCallback } from 'react'
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import pdf from '../../images/pdf.png'
import axios from "axios";
import { getDealFilingsApi } from '../../Config/config'
import moment from 'moment'
import useModule from '../../hooks/useModule';


/* The above code is a React component called "Filings". It is responsible for rendering a list of
filings based on the provided data. */
const Filings = (props) => {
  const date = moment(props?.data?.date).format("MMM YYYY")
  const [DealDate, setDealDate] = useState()
  const {isPE, isVC, isRE, isMA, isCFS } = useModule()
  const [data, setData] = useState({});
  const [open, setOpen] = useState(date);
  const [dataCount, setDataCount] = useState(0)
  const handleOpen = (date) => {  
    setOpen(open === date ? 0 : date);
  };

  useEffect(() => { 
    
    if(props?.data){
          if(props?.data[0]?.date){
            setOpen(moment(props?.data[0]?.date).format("MMM YYYY"))
          } 
          // handleOpen(moment(props?.data[0]?.date).format("MMM YYYY"))
        }
    if(props?.cname) 
    {
      filingsRender() 
    }

  }, [props?.data, props?.cname]);

  console.log("open-date", open,props);
  const filingsRender = useCallback(() => {
    axios(`${getDealFilingsApi}`, {
      method: "POST",
      data: { company_name: props?.cname, 
              type        : isPE ? 1 :isVC ? 2 : isRE ? 3 : isMA ? 4 : isCFS ? 5 :1 ,
              deal_date   : DealDate
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response?.data?.message === "Success") {
          setDataCount(response?.data?.data_count)
          setData(response?.data?.data)
        }
      })
      .catch((error) => {
        console.log("API not working", error);
      });

  }, [props?.cname, date]);
  console.log(data, 'axios api response1');
  const customStyles = {
    border: 'none'
  }
  return (
    dataCount >0 ?
      <div
        className="pt-4 pb-2 mb-5 mt-5 lg:mt-0 bg-[#FFFFFF] shadow-[0_2px_6px_0_rgba(0,0,0,0.08)] rounded-[4px]">

        <div className="px-5">
          <p className="text-[15pt] leading-[19pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">Filings</p>
        </div>
        <div className="px-6" id="custom-border-remove">
          {data ? (
            Object.keys(data).length > 0 ? (
              Object.entries(data[0]).map(([key, value]) => {
                console.log(value, 'flilings loop key')
                const index = Object.keys(data[0]).length - 1;
                const lastKey = Object.keys(data[0])[index];
                console.log(lastKey, 'lastkey')
                const lastValue = data[lastKey];
                console.log('open: ',open,'key :',key);
                return (
                  <Accordion open={open === key} className={open === key ? "border-none " : ""}>
                    <AccordionHeader onClick={() => handleOpen(key,value?.show)} className={open === key ? "custom-accordin font-sans_book_body flex justify-between items-center w-full pb-2 pt-4 text-[12pt] leading-[16pt] lg:text-[14px] lg:leading-[18px] text-[#333333] " : "pb-4"} >
                      <p className="text-[12pt] leading-[16pt] lg:text-[14px] lg:leading-[18px] font-sans_book_body text-[#333333] text-left">{key}</p>
                    </AccordionHeader>
                    <AccordionBody className="py-0 divide-y space-y-2">
                      {Object.entries(value['data']).map(([keys, values]) => {
                        return(
                        Object.entries(values).map(([keys1, values1]) => {
                        console.log(values1,'values of dealdate');
                        return ( 
                          <div className='py-3 lg:py-0 flex border-l-[3px] border-l-[#BC8B20] justify-between bg-[#F3F3F3] items-center w-[100%]'>
                            <a className='mt-2 text-[12pt] leading-[16pt] lg:text-[14px]  text-[#333333] lg:leading-[18px] pl-2 h-[2.5rem] flex items-center w-[90%]' href={values1} target='_blank'>{keys1}</a>
                            <a href={values1} target='_blank' className='pr-3 w-[35px] h-[30px]'><img src={pdf} className="" alt="pdf"/></a>
                            <br />
                          </div>
                        )})
                        )
                      })}
                    </AccordionBody>
                  </Accordion>

                )
              }))
              : <center><div className="bg-[#F3F3F3] p-3 h-[2.5rem] text-[14px] leading-[16px] font-sans_book_body text-[#333333] relative mt-[1rem] ">No data available</div></center>

          )
            :
            <div className="w-full bg-[#FFFFFF]">
              <center><div role="status" className=" h-[8rem]">
                <svg className="relative top-[4rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
              </div></center>
            </div>
          }

        </div>
      </div>
      : ""
  )
}

export default Filings